import ContactSection from "@/components/feature/ContactSection";

export default function Contact() {
  return <ContactSection id="contact" showHeading={true} />;
}